export class AwsDatabaseDestination {
    'restoreRegion';
    'encryptionKeyId';
    'restoredName';
    'securityGroups';
    'subnetGroup';
    'dbInstanceClass';
    'tags';
    'databaseFilter';
    'passwordConfig';
    'preserveInstanceNames';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreRegion",
            "baseName": "restoreRegion",
            "type": "string",
            "format": ""
        },
        {
            "name": "encryptionKeyId",
            "baseName": "encryptionKeyId",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoredName",
            "baseName": "restoredName",
            "type": "string",
            "format": ""
        },
        {
            "name": "securityGroups",
            "baseName": "securityGroups",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "subnetGroup",
            "baseName": "subnetGroup",
            "type": "string",
            "format": ""
        },
        {
            "name": "dbInstanceClass",
            "baseName": "dbInstanceClass",
            "type": "string",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "databaseFilter",
            "baseName": "databaseFilter",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "passwordConfig",
            "baseName": "passwordConfig",
            "type": "RdsPasswordConfig",
            "format": ""
        },
        {
            "name": "preserveInstanceNames",
            "baseName": "preserveInstanceNames",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsDatabaseDestination.attributeTypeMap;
    }
    constructor() {
    }
}
